import { format, parseISO } from "date-fns";
// import Pagination from "rc-pagination";
import { Pagination } from "antd";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import animation from "../../../../images/jm-animation.gif";
import Arrow from "../../../../images/mc_notice-box-arrow.png";
import ArrowNew from "../../../../images/newIcon/file-download 1.svg"
import URLstateContext from "../../../../provider/CommonContext";
import {
  DecryptAESdata,
  GetPostMethodData,
} from "../../../../provider/ServiceProvider";
import "./DocumentGalleryInner.css";
function DocumentGalleryInner() {
  const [data, setData] = useState([]);
  const [loadingshow, setLoadingshow] = useState(false);
  const [current, setCurrent] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [size, setSize] = useState(perPage);
  const [selectedYear, setSelectedYear] = useState("");
  const { BaseURL, fontSize } = useContext(URLstateContext);

  // Extract categoryId from window.location
  const categoryId = (() => {
    const parts = window.location.pathname.split("/");
    return parts[parts.length - 1];
  })();
  const categoryName = (() => {
    const parts = window.location.pathname.split("/");
    const lastPart = parts[parts.length - 2];
    const transformedName = lastPart.replace(/-/g, " ");
    return transformedName;
  })();


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setLoadingshow(true);
    // Fetch data based on categoryId from URL
    GetPostMethodData(BaseURL + "GetDocumentGalleryMain", {
      IICategoryID: categoryId,

    })
      .then((responseData) => {
        if (responseData.data != null && responseData.data.length > 0) {
          setData(DecryptAESdata(responseData.data));
          setLoadingshow(false);
          // console.log(
          //   "/Insights/DocumentGallery/" +
          //     DecryptAESdata(responseData.data.LinkLocation)
          // );
        } else {
          setData([]);
          setLoadingshow(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoadingshow(false);
      });
  }, [BaseURL, categoryId]);

  let PageSize = size;

  const PaginationChange = (page, pageSize) => {
    setCurrent(page);
    setSize(pageSize);
  };

  const currentTableData = useMemo(() => {
    const filteredData = selectedYear
      ? data.filter(
          (item) =>
            new Date(item.DocumentDate).getFullYear() === parseInt(selectedYear)
        )
      : data;

    if (filteredData.length > 0) {
      const firstPageIndex = (current - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      return filteredData.slice(firstPageIndex, lastPageIndex);
    }
    return [];
  }, [current, PageSize, data, selectedYear]);

  const PrevNextArrow = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        
          <i className="fa fa-angle-left" aria-hidden="true"></i>
        
      );
    }
    // git check
    if (type === "next") {
      return (
        
          <i className="fa fa-angle-right" aria-hidden="true"></i>
        
      );
    }
    return originalElement;
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    setCurrent(1); // Reset to the first page
  };

  function getDistinctYears(data) {
    const distinctYearsSet = new Set(
      data.map((item) => new Date(item.DocumentDate).getFullYear())
    );
    const yearsArray = Array.from(distinctYearsSet);

    // Sort years in descending order
    yearsArray.sort((a, b) => b - a);

    // Remove upcoming financial year
    const currentYear = new Date().getFullYear();
    return yearsArray.filter((year) => year <= currentYear);
  }

  return (
    <main>

    <section
      className="Nav-detail about-detail reachout Media-center padding-top"
      style={{ fontSize: `${fontSize}px` }}
    >
      <Container>
        <Row>
          <Col>
            <ul className="navigator-arrow">
              <li>

                <a href="/" aria-label="Home">
                  <i className="fa fa-home" aria-hidden="true">
                    <span className="sr-only">Home</span>
                  </i>
                </a>{" "}
              </li>
              <li>
                <a href="/Insights">Insights</a>{" "}
                <i className="fa fa-angle-right" aria-hidden="true"></i>
              </li>
              <li>{categoryName}</li>
            </ul>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col
            sm={12}
            className="padding-left-0"
            style={{
              borderColor: "white",
              padding: "20px",
              border: "none",
              maxWidth: "100%",
              margin: "15px 15px",
            }}
          >
            <div
              className="dg-inner-head"
              // style={{
              //   display: "flex",
              //   justifyContent: "space-between",
              //   marginBottom: "20px",
              // }}
            >
              <h1>{categoryName}</h1>
              <div className="downlode-container">
                <div
                  className="select-bar"
                  style={{ display: "flex", gap: "9px" }}
                >
                  <p
                    className="fin-year p-1 p-md-0 fs-6"
                    id="yearsdroplab"
                    style={{ display: "inline-block" }}
                  >
                    FY{" "}
                  </p>
                  <div className="select-container" id="yearsdrop">
                    <select
                      name="fund"
                      id="fund"
                      style={{
                        padding: "4px",
                        border: "1px solid #013c66",
                        borderRadius: "6px",
                      }}
                      className="data-selector"
                      value={selectedYear}
                      onChange={handleYearChange}
                      autoComplete="off"
                    >
                      <option value="">All Year</option>
                      {data &&
                        getDistinctYears(data).map((year) => (
                          <option key={year} value={year}>
                            {year - 1} - {year}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {currentTableData.length === 0 && !loadingshow && (
              <h5 className="errormsgComNew" role="alert">No Data Available !!!</h5>
            )}
            {currentTableData.map(
              ({
                Title,
                LinkLocation,
                DocumentDate,
                ThumbnailImage,
                CommunicationID,
              }) => (
                <div className="ads-container" key={CommunicationID}>
                  <div
                    className="notice-box"
                    style={{
                      background: "#fff",
                      borderRadius: "12px",
                      boxShadow: "0 4px 14px 0 rgba(0, 0, 0, .06)",
                      padding: "15px 60px 15px 15px",
                      position: "relative",
                      width: "100%",
                      marginBottom: "15px",
                    }}
                  >
                    <div className="datee">
                      {DocumentDate
                        ? format(parseISO(DocumentDate), "do MMM, yyyy")
                        : ""}
                    </div>
                    <p className="title">
                      <div>
                        <span>{Title}</span>
                      </div>
                      {/* {LinkLocation && (
                        <span className="arrow-iconn">
                          <img
                            src={Arrow}
                            className="arrow-iconn curserpointer"
                            alt="Arrow"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              window.open(
                                `/CMS/Insights/pdf/${LinkLocation}`,
                                "_blank"
                              );
                            }}
                            style={{
                              width: "40px",
                              height: "auto",
                            }}
                          />
                        </span>
                      )} */}
                      {LinkLocation && (
                          <a
                            href={`/CMS/Insights/pdf/${LinkLocation}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="arrow-iconn"
                            aria-label={`Open ${Title} document in a new tab`}
                          >
                            <img
                              src={ArrowNew}
                              alt=""
                              aria-hidden="true"
                              style={{
                                width: "40px",
                                height: "auto",
                              }}
                            />
                          </a>
                        )}
                    </p>
                  </div>
                </div>
              )
            )}
            {loadingshow && (
              <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                <img src={animation} alt="" aria-hidden="true" />
                <div className="model_popup">Please Wait...</div>
              </div>
            )}
            {currentTableData.length > 0 && (
              <Pagination
              align="end"
                className="pagination-data"
                onChange={PaginationChange}
                total={
                  selectedYear
                    ? data.filter(
                        (item) =>
                          new Date(item.DocumentDate).getFullYear() ===
                          parseInt(selectedYear)
                      ).length
                    : data.length
                }
                current={current}
                pageSize={size}
                showSizeChanger={false}
                showTitle = {false}
                itemRender={PrevNextArrow}
              />
            )}
          </Col>
        </Row>
      </Container>
    </section>

    </main>
  );
}

export default DocumentGalleryInner;
